export const loading = (state) => state.loading

export const collection = (state) => state.collection

// export const collections = (state) => state.collections || []
